<script>
import { mapGetters, mapState } from 'vuex'

export default {
    props: { premioId: Number, quatidade: Number },
    data: function() { return { quantidade: 1 };
    },
    methods: {
        incrementaPremio: function() {
            this.quantidade += 1;
        },
        decrementaPremio: function() {
            this.quantidade = Math.max(1, this.quantidade - 1);
        },
        adicionaPremio: function() {
            var vm = this,
                premio = {
                    premio_id: this.premioId,
                    quantidade: this.quantidade
                };

            this.$store.dispatch('campanhapontos/adicionarPremio', premio)
                .then(result => {
                    vm.$toasted.success('Item adicionado', {duration:3000, keepOnHover: true});
                })
                .catch(error => {
                    vm.$toasted.error(error, {duration:5000, keepOnHover: true, icon:'exclamation-circle'});
                });
        }
    },
    mounted() {
        this.quantidade = this.quantidade;
    },
    computed: {
        ...mapState({
        	premios: state => state.campanhapontos.premios,
        	isLoading: state => state.campanhapontos.isLoading
        }),
        premioAdicionado: function() {
            var returnKey = -1;
            var busca = this.premioId;
            $.each(this.premios, function(key, info) {
                //console.log(busca)
                if (info.premio_id == busca) {
                returnKey = key;
                return false; 
                };   
            });
            return returnKey; 
        },
        premioQuantidadeAdicionado: function() {
            var qtdValue = 1;
            var busca = this.premioId;
            $.each(this.premios, function(key, info) {
                if (info.premio_id == busca)
                {
                    qtdValue = parseInt(info.quantidade);
                };   
            });
            return qtdValue; 
        }
    }

};
</script>